// extracted by mini-css-extract-plugin
module.exports = {"resultsCount":"styles-module__resultsCount___36z_e","text":"styles-module__text___2XopS","hidden":"styles-module__hidden___2v8bb"};